import React, {useEffect} from 'react'
import {Link, useHistory} from 'react-router-dom'
// import VISA from '../../media/felsv/Visa.png'
import TableDetallePago from './Components/TableDetallePago'
import {useDispatch, useSelector} from 'react-redux'
import {
  suscripcionSetDetallePago,
  suscripcionSetSeleccion,
} from '../../actions/suscripcion/suscripcion.actions'
import {bindActionCreators} from 'redux'
import {actionsSuscripcion} from '../../actions/action-creators'
import {State} from '../../reducers'
import CardComprobantes from './Components/CardComprobantes'

const SuscripcionInfo = () => {
  const seleccion = useSelector((state: State) => state.suscripcion.seleccion)
  const detallePago = useSelector((state: State) => state.suscripcion.detallePago)
  const history = useHistory()
  const dispatch = useDispatch()
  const {suscripcionPostDetallePago} = bindActionCreators(actionsSuscripcion, dispatch)

  useEffect(() => {
    if (seleccion === null) history.push('/suscripcion/info')
    suscripcionPostDetallePago()
    return () => {
      dispatch(suscripcionSetSeleccion(null))
      dispatch(suscripcionSetDetallePago(null))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <div className='header'>
        <Link to='/suscripcion/info' className='back-button w-inline-block'></Link>
        <h3 className='h3-titles xl'>Suscripción</h3>
      </div>
      <div className='separador'></div>
      <CardComprobantes/>
    </>
  )
}

export default SuscripcionInfo
